import { useState, useRef, useEffect } from "react"
import cx from "classnames"

import { ReactComponent as LowshelfIcon } from "@/icons/lowshelf-icon.svg"
import { ReactComponent as PeakingIcon } from "@/icons/peaking-icon.svg"
import { ReactComponent as HighshelfIcon } from "@/icons/highshelf-icon.svg"

const FilterTypeOption = ({ type, label, className, onClick }) => {
  const getIcon = () => {
    switch (type) {
      case "lowshelf":
        return <LowshelfIcon className="-mb-[2px] h-3 w-3" />
      case "peaking":
        return <PeakingIcon className="-mb-[2px] h-3 w-3" />
      case "highshelf":
        return <HighshelfIcon className="-mb-[2px] h-3 w-3" />
      default:
        return null
    }
  }
  return (
    <div onClick={onClick} className={className}>
      {getIcon()}
      <span>{label}</span>
    </div>
  )
}

const FilterTypeSelect = ({ value, onChange, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const options = [
    { type: "lowshelf", label: "LS" },
    { type: "peaking", label: "PK" },
    { type: "highshelf", label: "HS" },
  ]

  const selectedOption = options.find((opt) => opt.type === value)

  return (
    <div className={cx("relative", className)}>
      <div className="inline-block" ref={dropdownRef}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={cx(
            "transition-color flex h-7 w-16 cursor-pointer items-center overflow-hidden rounded-plus border",
            isOpen
              ? "border-mine-shaft bg-[#212121] shadow-inside"
              : "border-earth bg-mine-shaft hover:border-silver"
          )}
        >
          {selectedOption && (
            <FilterTypeOption
              type={selectedOption.type}
              label={selectedOption.label}
              className="pointer-events-none flex items-center gap-2 px-2.5 py-1 font-ibm text-xs font-semibold text-silver-light"
              onClick={() => {}}
            />
          )}
        </div>
        {isOpen && (
          <div className="absolute z-10 mt-1 w-24 space-y-px overflow-hidden rounded-plus border border-[#393939] bg-dark p-1.25 shadow-outside">
            {options.map((option) => (
              <FilterTypeOption
                key={option.type}
                type={option.type}
                label={option.label}
                className={cx(
                  "flex items-center gap-2 rounded px-2.5 py-0.75 font-ibm text-xs font-semibold text-silver-light",
                  option.type === value
                    ? "pointer-events-none border border-cape-cod bg-mine-shaft"
                    : "cursor-pointer hover:bg-tundora hover:text-white"
                )}
                onClick={() => {
                  onChange(option.type)
                  setIsOpen(false)
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default FilterTypeSelect
